
import {
    computed,
    defineComponent,
    onBeforeMount,
    reactive,
    ref,
    toRaw,
    watch
} from "vue";
import XLSX from "xlsx";
import { apiErrorCatch, apiRequest, apiSign } from "@/common/http";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";
import cigoLayer from "@/components/cigo-layer";

export default defineComponent({
    name: "ImportExcelData",
    components: {
        CigoIconFont
    },
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        let xlsxObj = null;
        const doSubmit = () => {
            new Promise((resolve, reject) => {
                ctx.emit(
                    "notify",
                    "ok",
                    toRaw(dataListRef.value),
                    resolve,
                    reject
                );
            })
                .then(() => {
                    ctx.emit("close");
                })
                .catch(() => {
                    console.log("hold on");
                });
        };

        const cancel = () => {
            ctx.emit("close");
        };

        /*************************************************/
        const tableScroll = Object.assign(
            {
                x: 1500,
                y: "max-content"
            },
            props.layerData.tableScroll ? props.layerData.tableScroll : {}
        );
        const columns = computed(() => {
            let middleColumns: any[] = [];

            if (props.layerData.customColumns && props.layerData.columns) {
                middleColumns = [...props.layerData.columns];
            } else {
                if (dataListRef.value.length > 0) {
                    let colKeys = Object.keys(dataListRef.value[0]);
                    colKeys.every((key, index, arr) => {
                        middleColumns.push(
                            Object.assign(
                                index < arr.length - 1
                                    ? { width: "150px" }
                                    : {},
                                {
                                    title:
                                        props.layerData.columnsNameMap &&
                                        props.layerData.columnsNameMap.has(key)
                                            ? props.layerData.columnsNameMap.get(
                                                  key
                                              )
                                            : key,
                                    dataIndex: key
                                }
                            )
                        );
                        return true;
                    });
                }
            }

            return [
                {
                    title: "序号",
                    dataIndex: "__rowNum__",
                    width: "80px"
                },
                ...middleColumns,
                {
                    title: "操作",
                    key: "operation",
                    fixed: "right",
                    width: 80,
                    slots: {
                        customRender: "operation"
                    }
                }
            ];
        });
        let dataListRef: any = ref([]);
        const removeRow = (record: any) => {
            cigoLayer.confirm({
                layerData: {
                    msg: "确定删除吗？",
                    showCancel: true
                },
                ok: () => {
                    let tmpList = [...dataListRef.value];
                    tmpList.splice(tmpList.indexOf(record), 1);
                    dataListRef.value = [...tmpList];
                }
            });
        };
        /*************************************************/

        let vFileRef: any = ref(null);
        let selectedFileRef: any = ref(null);
        let xlsxFileData: any = ref([]);
        watch(xlsxFileData, (newVal: any) => {
            if (newVal.length && newVal[0].sheet) {
                dataListRef.value = [...newVal[0].sheet];
            } else {
                dataListRef.value = [];
            }

            console.log("sheetData:", dataListRef.value);
        });
        const chooseFile = () => {
            vFileRef.value.click();
        };
        const fileSelectChange = (fileList: any[]) => {
            if (!fileList || fileList.length == 0) {
                return;
            }
            selectedFileRef.value = fileList[0];
            checkFile()
                .then(() => {
                    return readFileData();
                })
                .then((sheetData: any) => {
                    xlsxFileData.value = [...sheetData];
                });
        };
        /*************************************************/
        const readFileData = () => {
            return new Promise((resolve, reject) => {
                var fileReader = new FileReader();
                fileReader.onload = event => {
                    if (!event.target) {
                        return;
                    }
                    var fileData = event.target.result;
                    xlsxObj = XLSX.read(fileData, {
                        type: "binary"
                    });
                    console.log("xlsxObj:", xlsxObj);

                    if (xlsxObj.SheetNames.length == 0) {
                        cigoLayer.msg("Excel没有sheet？");
                        return;
                    }
                    resolve([
                        {
                            sheetName: xlsxObj.SheetNames[0],
                            sheet: XLSX.utils.sheet_to_json(
                                xlsxObj.Sheets[xlsxObj.SheetNames[0]]
                            )
                        }
                    ]);
                };
                fileReader.readAsBinaryString(toRaw(selectedFileRef.value));
            });
        };
        const checkFile = () => {
            return new Promise((resolve, reject) => {
                if (!window.FileReader) {
                    cigoLayer.msg("不支持读取本地File");
                    return;
                }
                const suffix = selectedFileRef.value.name.split(".")[1];
                const fileType = ["xlsx", "xls", "csv"].some(
                    item => item === suffix
                );
                if (!fileType) {
                    cigoLayer.msg("请上传xls,xlsx,csv格式的文件");
                    return;
                } else {
                    resolve();
                }
            });
        };

        /*************************************************/

        return {
            tableScroll,
            columns,

            dataListRef,
            vFileRef,
            chooseFile,
            fileSelectChange,
            removeRow,

            doSubmit,
            cancel
        };
    }
});
